import { useEffect } from 'react';
import { useModalStore } from '../../store/modal';
import Modal from './Modal';
import ConfirmationModal from './ConfirmationModal';
import MessageModal from './MessageModal';

function ModalManager() {
  const { type, data, isOpen, closeModal } = useModalStore();

  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  switch (type) {
    case 'confirm':
      return (
        <ConfirmationModal
          isOpen={true}
          onClose={closeModal}
          title={data.title || ''}
          message={data.message || ''}
          onConfirm={data.onConfirm || closeModal}
          confirmText={data.confirmText}
          cancelText={data.cancelText}
          variant={data.variant}
        />
      );
    case 'message':
      return (
        <MessageModal
          isOpen={true}
          onClose={closeModal}
          title={data.title || ''}
          message={data.message || ''}
        />
      );
    case 'create':
    case 'edit':
      return (
        <Modal
          isOpen={true}
          onClose={closeModal}
          title={data.title || ''}
          size={data.size || 'md'}
        >
          {data.content}
        </Modal>
      );
    default:
      return null;
  }
}

export default ModalManager;